export default {
  apiServerUrl: 'https://localhost:8080/', // 'https://finhub.devsafi.pl/panel/',
  isMobileApp: 0,
  cookieBannerDebugMode: 1
};